const config = {
    baseUrl: ( process.env.NODE_ENV === 'development') ? "http://localhost:8000/api" : "https://www.api.digitalascendent.com/api"
    // baseUrl: "https://www.api.digitalascendent.com/api"
}

export default config;